import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
// import style from './_HighlightBusinessBox.scss';
import {HighlightBusinessBox} from 'components/highlight-businesses';
import {HighlightBusinesses} from 'base/api';
import { ShowIf, NoContent } from 'components/utils';

class HighlightBusinessList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.loadHighlightBusinessesFromServer = this.loadHighlightBusinessesFromServer.bind(this);
    this.postLoadHighlightBusinesses = this.postLoadHighlightBusinesses.bind(this);

    this.state = {
      items: {},
      listHighlightBusinesses: [],
      isLoading: false
    }
  }

  componentDidMount() {
    this.loadHighlightBusinessesFromServer();
  }

  loadHighlightBusinessesFromServer() {
    this.setState({isLoading: true}, () => {
      HighlightBusinesses.actions.list.request().then(response => {
        this.postLoadHighlightBusinesses(response.data);
      });
    })
  }

  postLoadHighlightBusinesses(highlightBusinesses) {
    // this.props.dispatch({
    //   type: 'UPDATE_HOME_BANNERS_LIST',
    //   highlightBusinesses: highlightBusinesses
    // });
    this.setState({
      listHighlightBusinesses: highlightBusinesses,
      isLoading: false
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listHighlightBusinesses != this.state.listHighlightBusinesses) {
      this.setState({isLoading: true}, () => {
        this.setState({
          listHighlightBusinesses: nextProps.listHighlightBusinesses
        }, () => {
          this.setState({isLoading: false});
        });
      });
    }
  }

  render() {
    const {isLoading, listHighlightBusinesses} = this.state;
    return (
      <div className='container-fluid'>
        <div className="container-fluid">
          <section className="list-home-banner">
            <ShowIf condition={isLoading || (listHighlightBusinesses && listHighlightBusinesses.length === 0)}>
              <div className="row">
                <NoContent
                  content={isLoading ? 'Đang tải dữ liệu...' : 'Không có kết quả nào'}
                  height={300}
                />
              </div>
            </ShowIf>
            <ShowIf condition={!isLoading && listHighlightBusinesses && listHighlightBusinesses.length > 0}>
              <div className="row">
                {listHighlightBusinesses.map((banner, index) => (
                  <HighlightBusinessBox key={index} data={banner}/>
                ))}
              </div>
            </ShowIf>
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    listHighlightBusinesses: state.listHighlightBusinesses
  };
}

export default connect(mapStateToProps)(HighlightBusinessList);



// WEBPACK FOOTER //
// ./components/highlight-businesses/HighlightBusinessList.jsx